import React from "react";
import type { ChakraProps, HeadingProps } from "@chakra-ui/react";
import { Box, Heading } from "@chakra-ui/react";

type PDPBodySectionProps = ChakraProps & {
  title: string;
  headingProps?: HeadingProps;
  customHeading?: JSX.Element;
  children?: React.ReactNode;
  containerProps?: ChakraProps;
};

export const PDPBodySection: React.FC<PDPBodySectionProps> = ({
  children,
  title,
  headingProps,
  customHeading,
  containerProps,
  ...otherProps
}) => {
  return (
    <Box w="full" {...otherProps}>
      {customHeading || (
        <Heading
          size="lg"
          display={{ base: "none", lg: "unset" }}
          as="h2"
          {...headingProps}
        >
          {title}
        </Heading>
      )}
      <Box mt={{ base: 0, lg: 1.5 }} width="100%" {...containerProps}>
        {children}
      </Box>
    </Box>
  );
};
